'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function GRFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("mask", { id: "mantine-qngpwmrh6", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-qngpwmrh6)" }, /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("g", { fill: "#4564f9" }, /* @__PURE__ */ React.createElement("path", { d: "M32 15.943V18.9H0v-2.957zm0-5.128v2.957H0v-2.957zM32 5.5v2.957H0V5.5zM0 0h32v3H0zm0 21h32v3H0z" }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h15v13.8H0z" })), /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M6 0h3v5.504h6v2.935H9V14.5H6V8.439H0V5.504h6z" })))
  );
}

export { GRFlag };
//# sourceMappingURL=GR.mjs.map
